export enum PermissionEnum {
  CNTT = "CNTT",
}
